"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UccCalendlyUrl = exports.MloCalendlyUrl = void 0;
var MloCalendlyUrl;
(function (MloCalendlyUrl) {
    MloCalendlyUrl["JULIA"] = "https://calendly.com/julia-beserman-aven/loan-officer";
    MloCalendlyUrl["JULIA_SHORT"] = "https://l.aven.com/julia";
    MloCalendlyUrl["JAMES"] = "https://calendly.com/james-mateer-aven/loan-officer";
    MloCalendlyUrl["DANIEL_SALTER"] = "https://calendly.com/daniel-salter-aven/mortgage-call";
})(MloCalendlyUrl || (exports.MloCalendlyUrl = MloCalendlyUrl = {}));
var UccCalendlyUrl;
(function (UccCalendlyUrl) {
    UccCalendlyUrl["GENERAL_SUPPORT"] = "https://calendly.com/avensupport1/call";
})(UccCalendlyUrl || (exports.UccCalendlyUrl = UccCalendlyUrl = {}));
